import { BrowserRouter, Route, Routes } from 'react-router'
import { MainLayout } from '@/components/layout'
import {
  HomePage,
  AboutPage,
  ProgrammesPage,
  ImpactPage,
  MagazinePage,
  TeamPage,
  GalleryPage,
  ContactPage,
  PartnerPage,
  DonatePage,
  PrivacyPage,
  TermsPage,
  NotFoundPage,
} from '@/pages'
import { ROUTES } from '@/constants/routes'
import { ScrollToTop } from './ScrollToTop'

const GlobalRoute = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route element={<MainLayout />}>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.ABOUT} element={<AboutPage />} />
        <Route path={ROUTES.PROGRAMMES} element={<ProgrammesPage />} />
        <Route path={ROUTES.IMPACT} element={<ImpactPage />} />
        <Route path={ROUTES.MAGAZINE} element={<MagazinePage />} />
        <Route path={ROUTES.TEAM} element={<TeamPage />} />
        <Route path={ROUTES.GALLERY} element={<GalleryPage />} />
        <Route path={ROUTES.CONTACT} element={<ContactPage />} />
        <Route path={ROUTES.PARTNER} element={<PartnerPage />} />
        <Route path={ROUTES.DONATE} element={<DonatePage />} />
        <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
        <Route path={ROUTES.TERMS} element={<TermsPage />} />
        <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
)

export default GlobalRoute
